import React from "react";
import MarketOverviewTable from "../MarketOverviewTable";
import { useMarketOverviewData } from "../../../context/MarketOverviewContext";
import { DEFAULT_CATALYSTS } from "../../../constants/sections";

const IndicesTab = () => {
    const { rows } = useMarketOverviewData();
    const data = rows.filter(row => (row.category || row.Category) === "Indices");
    const INDICES_ORDER = ["S&P500", "NASDAQ", "RUSSELL 2000", "USDX", "EURX", "JPYX"];
    return <MarketOverviewTable data={data} title="Indices Analysis" defaultRowData={{ Category: "Indices" }} defaultCatalysts={DEFAULT_CATALYSTS.Indices} customSortOrder={INDICES_ORDER} />;
};

export default IndicesTab;
